import { RefObject, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PlanEntitlementKey } from '../../../../../../../api/graphql/generated';
import {
  FeatureTourRef,
  FeatureTourStep,
} from '../../../../../../../components/feature/feature-tour';
import { PaywallSubscriptionDetail } from '../../../../../../../components/paywall/paywall';
import { useHasEntitlement } from '../../../../../../../components/plan/plan-entitlement-hooks';

const useFlowItemMultipassTourSteps = (
  tourRef: RefObject<FeatureTourRef>
): FeatureTourStep[] => {
  const { i18n } = useTranslation();
  const hasWeldingMultipass = useHasEntitlement(
    PlanEntitlementKey.WELDING_MULTIPASS
  );

  const tour = useMemo(() => {
    const steps: FeatureTourStep[] = [
      {
        analyticKey: 'multipass_inputs_info',
        selector: 'multipass-number-of-passes',
        title: i18n.t('common:number_of_passes'),
        description: i18n.t('welding:multipass_tour_steps_number_of_passes'),
        position: {
          side: 'bottom',
          alignment: 'center',
        },
      },
      {
        analyticKey: 'multipass_angle_mode_info',
        selector: 'multipass-angle-mode',
        title: i18n.t('common:travel_work_angle'),
        description: i18n.t('welding:multipass_tour_steps_angle_mode'),
        position: {
          side: 'bottom',
          alignment: 'center',
        },
      },
      {
        analyticKey: 'multipass_schedule_info',
        selector: 'multipass-schedule',
        title: i18n.t('welding:multipass_schedule_settings'),
        description: i18n.t('welding:multipass_tour_steps_schedule'),
        position: {
          side: 'bottom',
          alignment: 'center',
        },
      },
    ];

    if (!hasWeldingMultipass) {
      steps.push({
        analyticKey: 'multipass_subscription',
        selector: 'multipass-number-of-passes',
        title: i18n.t('welding:multipass'),
        description: (
          <PaywallSubscriptionDetail
            planEntitlementKey={PlanEntitlementKey.WELDING_MULTIPASS}
            onBeforeNavigate={() => {
              tourRef.current?.stopTour();
            }}
          />
        ),
        position: {
          side: 'bottom',
          alignment: 'center',
        },
      });
    }

    return steps;
  }, [hasWeldingMultipass, i18n, tourRef]);

  return tour;
};

export { useFlowItemMultipassTourSteps };
